import DrawingToolDragDrop from './DrawingToolDragDrop';
import { withTranslation } from '../../../withTranslation';

export default withTranslation()(DrawingToolDragDrop);
